import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { breakpoints } from 'gatsby-theme-docz/src/theme/breakpoints';
import global from 'gatsby-theme-docz/src/theme/global';
export var Content = _styled("div", {
  target: "e10j0xs0"
})("width:100%;a.link{color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.link;
}, ";&:hover{opacity:0.9;}}@media screen and (max-width:", breakpoints.mobile, "px){table{display:block;overflow:auto;min-width:520px;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy94Yy9kZXYvZGlnaW1ha2VyLXVpL25vZGVfbW9kdWxlcy9AbmVqY20vZG9jei10aGVtZS1leHRlbmRlZC9zcmMvZ2F0c2J5LXRoZW1lLWRvY3ovY29tcG9uZW50cy9MYXlvdXQvY3VzdG9tLXN0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJaUMiLCJmaWxlIjoiL1VzZXJzL3hjL2Rldi9kaWdpbWFrZXItdWkvbm9kZV9tb2R1bGVzL0BuZWpjbS9kb2N6LXRoZW1lLWV4dGVuZGVkL3NyYy9nYXRzYnktdGhlbWUtZG9jei9jb21wb25lbnRzL0xheW91dC9jdXN0b20tc3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHticmVha3BvaW50c30gZnJvbSAnZ2F0c2J5LXRoZW1lLWRvY3ovc3JjL3RoZW1lL2JyZWFrcG9pbnRzJztcbmltcG9ydCBnbG9iYWwgZnJvbSAnZ2F0c2J5LXRoZW1lLWRvY3ovc3JjL3RoZW1lL2dsb2JhbCc7XG5cbmV4cG9ydCBjb25zdCBDb250ZW50ID0gc3R5bGVkLmRpdmBcbiAgd2lkdGg6IDEwMCU7XG5cbiAgYS5saW5rIHtcbiAgICBjb2xvcjogJHsoe3RoZW1lfSkgPT4gdGhlbWUuY29sb3JzLmxpbmt9O1xuXG4gICAgJjpob3ZlciB7XG4gICAgICBvcGFjaXR5OiAwLjk7XG4gICAgfVxuICB9XG5cbiAgQG1lZGlhIHNjcmVlbiBhbmQgKG1heC13aWR0aDogJHticmVha3BvaW50cy5tb2JpbGV9cHgpIHtcbiAgICB0YWJsZSB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgIG92ZXJmbG93OiBhdXRvO1xuICAgICAgbWluLXdpZHRoOiA1MjBweDtcbiAgICB9XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBnbG9iYWxTdHlsZXMgPSB7XG4gIC4uLmdsb2JhbCxcbiAgJyonOiB7XG4gICAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gIH0sXG4gICcuaC1vOmhvdmVyJzoge1xuICAgIHRyYW5zaXRpb246ICdvcGFjaXR5IC4ycyBlYXNlJyxcbiAgICBvcGFjaXR5OiAnLjgnLFxuICB9LFxuICAnYnV0dG9uLCBzZWxlY3QsIGlucHV0LCB0ZXh0YXJlYSc6IHtcbiAgICBmb250RmFtaWx5OiAnaW5oZXJpdCcsXG4gIH0sXG4gIGE6IHtcbiAgICBjb2xvcjogKHt0aGVtZX0pID0+IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICAnYTpob3Zlcic6IHtcbiAgICB0ZXh0RGVjb3JhdGlvbjogJ3VuZGVybGluZScsXG4gIH0sXG59O1xuIl19 */"));

if (typeof Content !== 'undefined' && Content && Content === Object(Content) && Object.isExtensible(Content) && !Object.prototype.hasOwnProperty.call(Content, '__filemeta')) {
  Object.defineProperty(Content, '__filemeta', {
    configurable: true,
    value: {
      name: "Content",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}

export var globalStyles = _objectSpread(_objectSpread({}, global), {}, {
  '*': {
    boxSizing: 'border-box'
  },
  '.h-o:hover': {
    transition: 'opacity .2s ease',
    opacity: '.8'
  },
  'button, select, input, textarea': {
    fontFamily: 'inherit'
  },
  a: {
    color: function color(_ref2) {
      var theme = _ref2.theme;
      return theme.colors.primary;
    }
  },
  'a:hover': {
    textDecoration: 'underline'
  }
});

if (typeof globalStyles !== 'undefined' && globalStyles && globalStyles === Object(globalStyles) && Object.isExtensible(globalStyles) && !Object.prototype.hasOwnProperty.call(globalStyles, '__filemeta')) {
  Object.defineProperty(globalStyles, '__filemeta', {
    configurable: true,
    value: {
      name: "globalStyles",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}